// extracted by mini-css-extract-plugin
export default {"columnNoPadding":"layout_column_no-padding_columnNoPadding"};